import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';



export function initializer(keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<any> => {
    
    return new Promise(async (resolve, reject) => {
      try {
        await keycloak.init({
          config: environment.keycloakConfig,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          },
          enableBearerInterceptor: true,
          bearerExcludedUrls: ['/clients/public']
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };
}